// @flow

import { isYoungerThanSeconds } from '../../../../common/time'

import type { State } from './state'

const DO_NOT_SHOW_WELCOME_MESSAGE_AFTER_CLOSED_FOR_HOURS = 24
const DO_NOT_SHOW_WELCOME_MESSAGE_AFTER_CHATBOT_STARTED_FOR_HOURS = 24

export const getters = {
  lastMessageReceivedRecently (state: State, getters: any, rootState: Object): boolean {
    const lastMessageReceived = rootState.messages.lastMessageReceived
    // $FlowFixMe
    return (!!lastMessageReceived && isYoungerThanSeconds(Date.parse(lastMessageReceived), 60 * 60 * DO_NOT_SHOW_WELCOME_MESSAGE_AFTER_CHATBOT_STARTED_FOR_HOURS))
  },
  isShowingOpenChat (state: State, getters: any, rootState: Object): boolean {
    if (!state.welcomeMessage) return false
    if (rootState.bubble.isOpenInitial) return false
    if (state.welcomeMessage.type !== 'open_chat') return false
    if (getters.closedByUserRecently) return false
    if (rootState.bubble.hasWebsiteChatBeenOpened) return false
    if (state.forceShowWelcomeMessage) return true

    return !getters.lastMessageReceivedRecently
  },
  isShowingWelcomeMessage (state: State, getters: any, rootState: Object): boolean {
    if (!state.welcomeMessage) return false
    if (rootState.bubble.isOpen) return false
    if (rootState.bubble.hasWebsiteChatBeenOpened) return false
    if (getters.closedByUserRecently) return false
    if (state.forceShowWelcomeMessage) return true

    return !getters.lastMessageReceivedRecently
  },
  closedByUserRecently (state: State): boolean {
    const closedByUserAt = state.closedByUserAt
    if (!closedByUserAt) return false

    return isYoungerThanSeconds(closedByUserAt, 60 * 60 * DO_NOT_SHOW_WELCOME_MESSAGE_AFTER_CLOSED_FOR_HOURS)
  }
}
